import { Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fit-text',
  template: `
  <svg #svg [attr.width]="width$ | async" [attr.height]="height$ | async">
    <g #g0 [attr.transform]="g0Transform$ | async">
      <g #g1 [attr.transform]="g1Transform$ | async">
        <g #g2 [attr.transform]="g2Transform$ | async">
          <text #te text-anchor="middle" dy="1em">{{text$ | async}}</text>
        </g>
      </g>
    </g>
  </svg>
  `,
  styles: [`
:host {
  display: block;
}
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FitTextComponent implements OnInit, AfterViewInit {

  @Input() set text(t: string) {
    this.text$.next(t);
  }
  @ViewChild('g1', { static: true }) g1: ElementRef;

  text$ = new BehaviorSubject(null);
  width$ = new BehaviorSubject(0);
  height$ = new BehaviorSubject(0);
  g0Transform$ = new BehaviorSubject<string>('');
  g1Transform$ = new BehaviorSubject<string>('');
  g2Transform$ = new BehaviorSubject<string>('');
  g1Rect: any;
  ready = false;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.text$.pipe(filter(p => !!p && this.ready)).subscribe(p => this.update());
  }

  ngAfterViewInit() {
    this.ready = true;
    this.g1Rect = this.g1.nativeElement.getBBox();
    setTimeout(() => this.update(), 0);
  }

  update() {
    this.g2Transform$.next(`translate(0, -${this.g1Rect.height / 2})`);

    const rect = this.elementRef.nativeElement.parentNode.getBoundingClientRect();

    const scaleX = rect.width / this.g1Rect.width;
    const scaleY = rect.height / this.g1Rect.height;

    const scale = Math.min(scaleX, scaleY);
    this.g1Transform$.next(`scale(${scale})`);

    const x = rect.width / 2;
    const y = rect.height / 2 - this.g1Rect.y;

    this.g0Transform$.next(`translate(${x}, ${y})`);

    this.width$.next(rect.width);
    this.height$.next(rect.height);
  }

  @HostListener('window:resize', ['$event'])
  resize(event) {
    this.update();
  }

}
